export default function HowToPurchase(productname) {
    let href;
    if(process.env.NODE_ENV === 'production'){
        href = 'https://morganstanley.csod.com/globalsearch/search.aspx#q=indexed%20life&s=1&a=typ%253d0%2526cus%253d%2525253cCustomFields%2525253e%2525253cfield%25252bid%2525253d%25252522184%25252522%25252bvalue%2525253d%252525221540%2525252c1904%2525252c1548%2525252c2525%2525252c1551%25252522%25252b%2525252f%2525253e%2525253c%2525252fCustomFields%2525253e';
    }else{
        href = 'https://morganstanley.csod.com/globalsearch/search.aspx#q=indexed%20life&s=1&a=typ%253d0%2526cus%253d%2525253cCustomFields%2525253e%2525253cfield%25252bid%2525253d%25252522184%25252522%25252bvalue%2525253d%252525221540%2525252c1904%2525252c1548%2525252c2525%2525252c1551%25252522%25252b%2525252f%2525253e%2525253c%2525252fCustomFields%2525253e';
    }
    
    switch(productname){
    case'IndexUniversalLife':
    return {
        title: "How to Purchase",
        contenttitle:`Initiate Case Design with approved Insurance GA Partners: `,
        linkcontent:'Permanent Insurance Case Design',
        paragraphs:`Note: All Financial Advisors (FAs) are required to take the Index Life Insurance training module available on <a href=${href} target="_blank">Knowledgelink</a>, prior to solicitation of the product. Or, type Knowledgelink into your browser, search keywords Indexed Universal Life Insurance Product Training. Once you have completed the training, please print out your completion certificate for your records.`
    }
    case 'VariableUniversalLife':
        return {
            title: "How to Purchase",
            contenttitle:`Initiate Case Design with approved Insurance GA Partners: `,
            linkcontent:'Permanent Insurance Case Design',
        }
    case 'UniversalLife':
        return {
            title: "How to Purchase",
            contenttitle:`Initiate Case Design with approved Insurance GA Partners: `,
            linkcontent:'Permanent Insurance Case Design',
        }
    case 'Wholelife':
        return {
            title: "How to Purchase",
            contenttitle:`Initiate Case Design with approved Insurance GA Partners: `,
            linkcontent:'Permanent Insurance Case Design',
    
         }
    default:
        return;
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/perm/HowToPurchaseData.js